import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ZINGLE_DEMO, ZINGLE_ANDROIDID , ZINGLE_IOSID, CMSPath } from "../../../config/constant"
import { freshchatWidgetShowConversation } from './freshchat';
import { zingleWidgetShowConversation } from './zingle';
import { zingleWebWidgetShowConversation } from './zingleWeb';
import { FreshchatWebWidgetShowConversation } from './freshchatWeb';
import { InnSpireChatShowConversation } from './innpirechatbot';
import { setUnreadMessageCountWeb } from '../../../action/action';
import { setGoHome } from '../../action/homeAction';
import Loader from '../../UI/loader';

class ChatBubble extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chatWidgetInit : false,
            showLoader: false,
        }
    }

    componentDidUpdate() {
        if(this.props.chatWidgetInnitialized && !this.state.chatWidgetInit){
            let isLoaderOn = this.state.showLoader

            setTimeout(() => {
                this.setState({chatWidgetInit: true, showLoader: false}, () => {
                    if(isLoaderOn){
                        this.openChat();
                    }
                });
            }, 1000);
        }
    }

    openChat = () => {
        //After initializing Freshchat

    if(this.state.chatWidgetInit){
    if(this.props.freshChatData.login.interfaceKey == "FRESHCHAT"){
        if(window.device){
            freshchatWidgetShowConversation()
        } else {
            FreshchatWebWidgetShowConversation();
        }
    }else if(this.props.freshChatData.login.interfaceKey == "ZINGLE"){
        if( window.device ){
            zingleWidgetShowConversation(this.props)
        } else {
            zingleWebWidgetShowConversation();
        }
    } else if (this.props.freshChatData.login.interfaceKey.toLowerCase() == "innspirechat") {
        InnSpireChatShowConversation(this.props);
    }} else {
        this.setState({showLoader: true})
    }}

    render() {
        return (
            <>
                {this.props.navbar ? (
                    <a onClick={this.openChat}
                    className={this.props.selectedHomePage.uniqueKey === this.props.widgetInfo.uniqueKey ? "footButton selected" : "footButton"}>
                        {+this.props.unreadMessageCount > 0 && <div class="alert">{+this.props.unreadMessageCount}</div>}
                        <span class="button-icon">
                            <img src={`${CMSPath}${this.props.widgetInfo.tabIconUrl}`} alt="not found" />
                        </span>
                        <span class="button-label">{this.props.widgetInfo.tabName}</span>
                    </a>
                ) : this.props.floatingWidgetRenderType === "BOTTOM_DOCKED" ? (
                    <div>
                        {+this.props.unreadMessageCount > 0 && <span className='unread-chat-count'>{+this.props.unreadMessageCount}</span>}
                        <a href="javascript:void(0);" onClick={this.openChat} className="tile-container" style={{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}}>
                            {this.props.widgetInfo.btnImageUrl ?
                                <span class="button-icon">
                                    <img src={`${CMSPath}${this.props.widgetInfo.btnImageUrl}`} />
                                </span> 
                                : <i class="fas fa-comment"></i>
                            }
                            <span class="button-icon">{this.props.widgetInfo.displayName}</span>
                        </a>
                    </div>
                ) : (
                    <div id='chatbox' class="chatbox">
                        { +this.props.unreadMessageCount > 0 && <span className='unread-chat-count'>{+this.props.unreadMessageCount}</span>}
                        <a href="javascript:void(0);" onClick={this.openChat} class="tile-container" style={{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}} >
                            {this.props.widgetInfo.btnImageUrl ?
                                <span class="button-icon">
                                    <img src={`${CMSPath}${this.props.widgetInfo.btnImageUrl}`} />
                                </span> 
                                : <i class="fas fa-comment-alt"></i>
                            }
                        </a>
                    </div>
                )}
                {this.state.showLoader && <Loader displayMsg="Initializing Chat" showClose={true} close={() => {this.props.setGoHome(true); this.setState({showLoader: false})}} />}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedHomePage: state.store2.currentHomePage,
        menuColor: state.store.home.MenuColor,
        freshChatData: state.store.freshChatData,
        chatWidgetInnitialized: state.store2.chatWidgetInnitialized,
        floatingWidgetRenderType : state.store.home.currentDuration.floatingWidgetRenderType ? state.store.home.currentDuration.floatingWidgetRenderType : null,
        unreadMessageCount: state.store2.unreadMessageCountChat
    }
}

export default connect(mapStateToProps, {setGoHome, setUnreadMessageCountWeb} )(ChatBubble);